import { useState } from 'react';

const EMPTY_FORM = {
  registration_number: '',
  last_name: '',
  first_name: '',
  email: '',
  phone: '',
  job_name: '',
  department_id: '',
  site_id: '',
  badge_number: '',
  fingerprint_id: '',
  face_id: '',
  card_id: '',
  hire_date: new Date().toISOString().split('T')[0],
  contract_end_date: '',
  birth_date: '',
  address: '',
  city: '',
  postal_code: '',
  salary: '',
  status: 'ACTIVE',
  contract_type: 'PERMANENT',
  role: 'EMPLOYEE',
  supervisor_id: '',
  coach_id: '',
  mentor_id: '',
  photo: null,
  is_postier: false,
  regime: '',
  // Gulf/GCC fields
  qid: '',
  is_expatriate: false,
  gosi_number: '',
  iqama_number: '',
  work_permit_number: '',
  work_permit_expiry: '',
  visa_residence_number: '',
  visa_residence_expiry: '',
  visa_work_number: '',
  visa_work_expiry: '',
  // Gulf salary structure (contributory base = basic + housing [+ social QA])
  basic_salary: '',
  housing_allowance: '',
  transport_allowance: '',
  other_allowances: '',
  social_allowance: '',
};

const useEmployeeForm = () => {
  const [formData, setFormData] = useState(EMPTY_FORM);
  const [photoPreview, setPhotoPreview] = useState(null);

  const updateField = (field, value) => {
    setFormData(prev => ({ ...prev, [field]: value }));
  };

  const resetForm = () => {
    setFormData({ ...EMPTY_FORM, hire_date: new Date().toISOString().split('T')[0] });
    setPhotoPreview(null);
  };

  const populateForm = (employee) => {
    setFormData({
      registration_number: employee.registration_number || '',
      last_name: employee.last_name || '',
      first_name: employee.first_name || '',
      email: employee.email || '',
      phone: employee.phone_number || '',
      job_name: employee.job_title || employee.job_name || '',
      department_id: employee.department_id?.toString() || '',
      site_id: employee.site_id?.toString() || '',
      badge_number: employee.badge_number || '',
      fingerprint_id: employee.fingerprint_id || '',
      face_id: employee.face_id || '',
      card_id: employee.card_id || '',
      hire_date: employee.hire_date || '',
      contract_end_date: employee.contract_end_date || '',
      birth_date: employee.birth_date || '',
      address: employee.address || '',
      city: employee.city || '',
      postal_code: employee.postal_code || '',
      salary: employee.salary || '',
      status: employee.status || 'ACTIVE',
      contract_type: employee.contract_type || 'PERMANENT',
      role: employee.role || 'EMPLOYEE',
      supervisor_id: employee.supervisor_id?.toString() || '',
      coach_id: employee.coach_id?.toString() || '',
      mentor_id: employee.mentor_id?.toString() || '',
      photo: null,
      is_postier: employee.is_postier || false,
      regime: employee.regime || '',
      // Gulf/GCC fields
      qid: employee.qid || '',
      is_expatriate: employee.is_expatriate || false,
      gosi_number: employee.gosi_number || '',
      iqama_number: employee.iqama_number || '',
      work_permit_number: employee.work_permit_number || '',
      work_permit_expiry: employee.work_permit_expiry || '',
      visa_residence_number: employee.visa_residence_number || '',
      visa_residence_expiry: employee.visa_residence_expiry || '',
      visa_work_number: employee.visa_work_number || '',
      visa_work_expiry: employee.visa_work_expiry || '',
      // Gulf salary structure
      basic_salary: employee.basic_salary ?? '',
      housing_allowance: employee.housing_allowance ?? '',
      transport_allowance: employee.transport_allowance ?? '',
      other_allowances: employee.other_allowances ?? '',
      social_allowance: employee.social_allowance ?? '',
    });
    setPhotoPreview(employee.picture_url || employee.photo_url || null);
  };

  return { formData, setFormData, updateField, resetForm, populateForm, photoPreview, setPhotoPreview };
};

export default useEmployeeForm;
